<template lang="pug">
v-container.mt-0
  save-recurring-task-modal(
    v-model='taskCopy',
    :showModal='showSavingRecurringTask',
    @close='saveTasks'
  )

  pagination-list-modal(
    v-if="showContactsDialog"
    v-model="showContactsDialog"
    :items="allContacts.slice(skip, skip + limit)"
    :total="allContacts.length"
    :limit="limit"
    :skip="skip"
    title="Task Contacts"
    description="A task will be created in these contacts:"
    @close="closeContactsDialog"
    @setPage="setContactsPage"
    @setPageLimit="setContactsPageLimit")
      template(slot="items" slot-scope="{ item }")
        v-layout(row)
          v-checkbox.pa-0.ma-0(:input-value="true" :disabled="shouldDisableContactsField" color='primary' @click="removeItem(item)" hide-details :style="{'flex':0}") 
          div {{item.name}}

  processing-action-modal(v-if='tasksBulkLoading')
  v-form(ref='form', v-model='valid')
    v-layout(wrap)
      v-flex(xs12, sm5)
        label Category
        v-select(
          attach,
          v-model='taskCopy.category',
          placeholder='None',
          :items='categories',
          item-text='name',
          item-value='id',
          return-object,
          prepend-icon='category',
          :readonly='isV1'
        )
      v-flex(xs12, sm6)
        label Status
        v-radio-group(v-model='status', row, :readonly='isV1')
          v-radio(label='Completed', value='complete')
          v-radio(label='Not Completed', value='incomplete')

      v-flex(v-if='taskCopy.is_nylas_task && !taskCopy.is_two_way_sync && id && !isV1', xs12)
        label {{ emailAccountSynced }}

      v-flex(v-if='((taskCopy.is_nylas_task && taskCopy.is_two_way_sync) || !id) && !isV1', xs12)
        v-tooltip(left, close-delay='5000', v-if='!!!enabledEmailAccounts.length')
          template(slot='activator')
            v-switch.mt-2.sync-toggle(
              hide-details,
              data-cy='toggle-contacts-v2-switch',
              label='Sync this task with 3rd party calendar',
              color='primary',
              disabled,
              :input-value='keepInSync',
              @change='setKeepInSync',
              slot='activator'
            )
          span= "You have not connected your calendar. "
            a(href='/email-integrations', target='_blank') Connect now
            | !{' to make the most out of LD'}

        v-switch.mt-2.sync-toggle(
          hide-details,
          data-cy='toggle-contacts-v2-switch',
          label='Sync this task with 3rd party calendar',
          color='primary',
          :input-value='keepInSync',
          @change='setKeepInSync',
          slot='activator',
          v-if='!!enabledEmailAccounts.length'
        )
        v-select(
          attach,
          v-if='taskCopy.is_two_way_sync && !id',
          v-model='taskCopy.emailAccountConnected',
          label='Email account to sync',
          :items='enabledEmailAccounts',
          :rules='syncAccountRules',
          item-text='email',
          item-value='id',
          return-object,
          :readonly='id > 0'
        )
        span(v-if='taskCopy.keepInSync && !!id') {{ emailAccountSynced }}
      v-flex(xs12)
        v-text-field(
          v-model='taskCopy.description',
          label='Description*',
          validate-on-blur,
          required,
          placeholder='What would you like to be reminded of?',
          :rules='descriptionRules',
          prepend-icon='short_text',
          :readonly='isV1'
        )
      v-flex(xs12)
        v-textarea(v-model='taskCopy.notes', label='Notes', prepend-icon='notes', :readonly='isV1')
      v-flex(xs12, sm8, v-if='this.teamMembers.length')
        v-select(
          v-if='isBulkTask'
          attach,
          v-model='taskCopy.assignedUsers',
          label='Assign To',
          :items='teamMembers',
          item-text='text',
          item-value='value',
          return-object,
          prepend-icon='person',
          chips,
          deletable-chips,
          multiple
          :readonly='isV1'
        )
        v-select(
          v-else
          attach,
          v-model='taskCopy.assignedUser',
          label='Assign To',
          :items='teamMembers',
          item-text='text',
          item-value='value',
          return-object,
          prepend-icon='person',
          chips,
          deletable-chips,
          :readonly='isV1'
        )
        label.no-icon-field-indent(
          v-if='taskCopy.assignedUsers && taskCopy.assignedUsers.length > 1'
        )
          | A copy of this task will be created for each assigned user.

      v-flex(xs12, sm4, v-if='this.teamMembers.length')
        v-checkbox(v-model='taskCopy.notifyAssignee', label='Notify Assignee', :readonly='isV1')
      v-flex(xs12)
        label.no-icon-field-indent Reminder
        v-radio-group.mt-0(
          v-model='taskCopy.action',
          row,
          prepend-icon='notifications',
          :readonly='isV1'
        )
          v-radio(
            v-for='action in actions',
            :key='action.key',
            :value='action.key',
            :label='`${action.name}`'
          )
      v-flex.pb-0.mb-0(xs12)
        v-autocomplete.pb-0.mb-0(
          attach,
          v-model='taskCopy.contactsSelected',
          label='Contact',
          :items='contacts ? contacts.concat(taskCopy.contactsSelected) : []',
          :search-input.sync='search',
          hide-no-data,
          item-text='name',
          item-value='id',
          prepend-icon='search',
          return-object,
          chips,
          deletable-chips,
          :disabled='shouldDisableContactsField',
          multiple,
          :readonly='isV1'
        )
          template(slot='selection', slot-scope='data')
            v-chip(v-if='data.index < 5') {{ data.item.name }}
            v-chip.clickable(v-if="data.index === 5" @click.stop="openContactsDialog") + {{ invisibleContactsCount }} more

        label.no-icon-field-indent(
          v-if='taskCopy.contactsSelected && taskCopy.contactsSelected.length > 1'
        )
          | A copy of this task will be created for each contact.
        p.pa-0.ma-0.pl-2.ml-4.caption.red--text.font-weight-bold(v-if="buttonDisable") {{ contactMandatoryText }}
      
      v-flex(xs12, sm4)
        v-menu(
          attach,
          ref='calendarMenu',
          :close-on-content-click='false',
          v-model='calendarMenu',
          :nudge-right='32',
          :nudge-top='50',
          :return-value.sync='taskCopy.dueDate',
          menu-props='{top:\'top\'}',
          lazy,
          transition='scale-transition',
          full-width,
          min-width='290px'
        )
          v-text-field(
            v-model='taskCopy.dueDate',
            slot='activator',
            :label='taskCopy.is_nylas_task || taskCopy.is_two_way_sync ? "Due/Start Date*" : "Due date*"',
            prepend-icon='event',
            readonly,
            :rules='dueDateRules',
            clearable
          )
          v-date-picker(
            v-model='taskCopy.dueDate',
            @change='manualyChanged',
            no-title,
            @input='$refs.calendarMenu.save(taskCopy.dueDate)',
            :readonly='isV1'
          )
        v-menu(
          attach,
          v-if='taskCopy.is_nylas_task || (taskCopy.is_two_way_sync && !id)',
          ref='calendarMenuEndAt',
          :close-on-content-click='false',
          v-model='calendarMenuEndAt',
          :nudge-right='32',
          :nudge-top='50',
          :return-value.sync='taskCopy.endAt',
          menu-props='{top:\'top\'}',
          lazy,
          transition='scale-transition',
          full-width,
          min-width='290px'
        )
          v-text-field(
            v-model='taskCopy.endAt',
            slot='activator',
            label='End Date*',
            prepend-icon='event',
            readonly,
            :rules='dueDateRules',
            clearable
          )
          v-date-picker(
            v-model='taskCopy.endAt',
            no-title,
            @input='$refs.calendarMenuEndAt.save(taskCopy.endAt)',
            :readonly='isV1'
          )
      v-flex(xs12, sm4)
        v-combobox(
          attach,
          menu-props='{top:\'top\'}',
          v-if='taskCopy.dueDate && !taskCopy.isAllDay',
          v-model='taskCopy.dueTime',
          :search-input.sync='taskCopy.dueTime',
          :label='taskCopy.is_nylas_task || taskCopy.is_two_way_sync ? "Due/Start time" : "Time"',
          prepend-icon='access_time',
          :items='timeSlots()',
          :rules='timeRules',
          :readonly='isV1'
        )
        v-combobox(
          v-if='(taskCopy.is_nylas_task || (taskCopy.is_two_way_sync && !id)) && taskCopy.dueDate && !taskCopy.isAllDay',
          attach,
          menu-props='{top:\'top\'}',
          v-model='taskCopy.dueEndTime',
          :search-input.sync='taskCopy.dueEndTime',
          label='End Time',
          prepend-icon='access_time',
          :items='timeSlots()',
          :rules='timeRules',
          :readonly='isV1'
        )

      v-flex(xs12, sm4)
        v-checkbox(
          v-if='taskCopy.dueDate',
          v-model='taskCopy.isAllDay',
          label='All Day Task?',
          :readonly='isV1'
        )

      v-flex(xs12, v-if='!isV1')
        v-layout
          v-flex(xs12)
            //- The Popup to customize recurrence schedule
            recurrence-picker(
              v-model='sendRecurring',
              :initialDate='initialDateParsed',
              :initialRule='initialRule',
              :manualStartDate='manualStartDate',
              @initDueDate='initDueDateAsToday()'
            )
      
</template>

<script>
import { createNamespacedHelpers, mapState } from 'vuex';
import dateFns from 'date-fns';
import TitleBar from '@/Core/components/TitleBar';
import ProcessingActionModal from '@/Contacts/components/actions/ProcessingActionModal';
import RecurrencePicker from '@/Tasks/components/RecurrencePicker';
import Recurrence from '@/Core/models/recurrence';
import Preferences from '@/Core/config/recurrence';
import features from '@/Email-Integrations/config/features';
import emailAccountTypes from '@/Email-Integrations/config/email-account-types';

import { timeSlots, timeRules } from '@/Core/utilities';
import { CONTACT_ASSIGNED, UPDATE_TASK_INTERVAL } from '../config/constants';
import SaveRecurringTaskModal from './SaveRecurringTaskModal';
import PaginationListModal from '@/Core/components/PaginationListModal'

const { mapGetters: mapUserInformationGetters } = createNamespacedHelpers(
  'userInformation',
);

const { mapState: mapTasksState, mapActions: mapTasksActions } = createNamespacedHelpers('tasks');
const {
  mapGetters: mapTeamMembersGetters,
  mapActions: mapTeamMembersActions,
} = createNamespacedHelpers('teamMembers');
const { mapState: mapUserInformationState } = createNamespacedHelpers('userInformation');
const { mapActions: mapEmailManagementActions } = createNamespacedHelpers('emailManagement');
const { 
  mapActions: mapContactsTableActions, 
  mapState: mapContactsTableState,
} = createNamespacedHelpers('contactsTable');

const actionsV21 = [
  {
    key: 'None',
    name: 'None',
  },
  {
    key: 'Email Contact',
    name: 'Email',
  },
  {
    key: 'Text Contact',
    name: 'Text',
  },
];

// Mocks the recurring data structure
const sendRecurringBaseCase = {
  name: null,
  recurrenceRule: null,
  startDate: null,
};

export default {
  components: {
    TitleBar,
    ProcessingActionModal,
    RecurrencePicker,
    SaveRecurringTaskModal,
    PaginationListModal,
  },
  props: {
    id: {
      default: null,
    },
    activeTab: {
      default: null,
    },
    queryParams: {
      type: Object,
      default: () => {},
    },
    contactIds: {
      type: Array,
      default: () => [],
    },
    allBulkContacts: {
      type: Array,
      default: () => [],
    },
    isBulkTask: {
      type: Boolean,
      default: false,
    },
    totalContactsSelected: {
      type: Number,
      default: 0,
    },
  },

  data() {
    // This is to load the contacts even before typing someting
    // this.findContacts("a")
    const initialStatus = this.task ? this.task.status : '';

    return {
      initialized: false,
      taskCopy: Object.assign({}, this.task),
      calendarMenu: null,
      calendarMenuEndAt: null,
      search: null,
      manualStartDate: null,
      actions: actionsV21,
      valid: false,
      descriptionRules: [v => !!v || 'Description is required'],
      syncAccountRules: [v => !!v || 'Email account to sync is required'],
      dueDateRules: [v => !!v || 'Due Date is required'],
      timeRules,
      timeSlots,
      saveTaskErrors: [],
      // Calendar options to select scheduled emails
      initialDateParsed: dateFns.parse(new Date()), // The parsed version of initialDateRaw.
      // Calendar options to set recurring intervals
      sendRecurring: sendRecurringBaseCase,
      initialRule: '',
      showSavingRecurringTask: false,
      status: initialStatus,
      keepInSync: this.task && this.task.is_nylas_task ? this.task.is_two_way_sync : false,
      contactMandatoryText: `'Contact Assignee' requires a Contact to be selected`,
      showContactsDialog: false,
      limit: 15,
      skip: 0,
      page: 1,
    };
  },

  computed: {
    ...mapTasksState([
      'categories',
      'contacts',
      'contactsSelected',
      'task',
      'assignedUsers',
      'tasksBulkLoading',
      'isEditTaskDrawerOpen',
      'buttonDisable',
    ]),
    ...mapState({
      emailAccounts: state => state.emailManagement.emailAccounts,
    }),
    ...mapTeamMembersGetters(['teamMembersInfo']),
    ...mapUserInformationState(['user']),
    ...mapContactsTableState(['visibleBulkContacts']),
    ...mapUserInformationGetters(['userHasFeatureFlag']),
    title() {
      return this.id ? 'Edit Task' : 'Add New Task';
    },
    saveTitle() {
      return this.id ? 'Update Task' : 'Create Task';
    },
    emailAccountSynced() {
      const emailAccount = this.enabledEmailAccounts.find(f => {
        return f.id === parseInt(this.task.email_account_connected_id);
      });

      if (!!emailAccount) {
        if (this.task.is_two_way_sync) {
          return 'Synced with ' + emailAccount.email;
        }
        return 'Imported from ' + emailAccount.email;
      }
      return '';
    },
    isV1() {
      return !this.task.isV21;
    },
    enabledEmailAccounts() {
      if (this.emailAccounts.length === 0) return [];
      return this.emailAccounts.filter(f => {
        // When enableing for Outlook and others, needs to allow here
        return (
          f.email_account_type_id === emailAccountTypes.gmail.id &&
          f.feature_ids &&
          f.feature_ids.includes(features.calendarSync.id)
        );
      });
    },
    teamMembers() {
      const teamMembersInfo = this.teamMembersInfo.map(teamMember => ({ ...teamMember }));

      teamMembersInfo.forEach(teamMember => {
        if (this.user && teamMember.value === this.user.id) {
          teamMember.text = 'Me';
        }
      });

      if (teamMembersInfo.length) {
        teamMembersInfo.splice(1, 0, {
          value: CONTACT_ASSIGNED,
          text: 'Contact Assignee',
        });
      }

      return teamMembersInfo;
    },
    visibleContacts() {
      return this.taskCopy.contactsSelected.slice(0, 5);
    },
    invisibleContacts() {
      return this.taskCopy.contactsSelected.slice(5);
    },
    allContacts() {
      return this.taskCopy.contactsSelected;
    },
    shouldDisableContactsField() {
      if (this.isBulkTask) {
        return this.totalContactsSelected > 0;
      }

      return this.contactIds && this.contactIds.length > 0;
    },
    invisibleContactsCount() {
      if (this.isBulkTask) {
        return this.totalContactsSelected - 5;
      }

      return this.invisibleContacts && this.invisibleContacts.length;
    },
  },

  watch: {

    'taskCopy.dueDate': {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.initialDateParsed = dateFns.parse(newVal);
          this.sendRecurring = sendRecurringBaseCase;
        }

        if (this.taskCopy.endAt == null) {
          this.taskCopy.endAt = newVal;
        }
      },
    },
    'taskCopy.status': {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.status = newVal;
        }
      },
    },

    taskCopy: {
      immediate: true,
      handler(value) {
        this.contactAssigneeSelected(value);
        
        if (this.initialized) {
          this.$emit('input', true);
        }
        if (!this.initialized) {
          if (value.recurrenceRule !== '') {
            const r = new Recurrence(value.dueTime, null, value.recurrenceRule);
            this.sendRecurring = {
              name: r.toDisplayString(),
              recurrenceRule: value.recurrenceRule,
              startDate: new Date(),
            };
            this.initialRule = value.recurrenceRule;
          }
          this.initialized = true;
        }

        return value;
      },
      deep: true,
    },
    task(value) {
      this.$refs.form.resetValidation();
      // notify parent that model is clean (no user input)
      this.$emit('input', false);
      this.initialRule = '';
      this.initialDateParsed = dateFns.parse(new Date());
      (this.keepInSync = value.is_nylas_task ? value.is_two_way_sync : false),
        (this.initialized = false);
      this.taskCopy = { ...value };
    },

    status(value) {
      this.taskCopy.status = value;
    },

    contactsSelected(value) {
      this.taskCopy.contactsSelected = value;
    },
    search(value) {
      this.findContacts(value);
    },
    /*
     * Watches for any changes in the sending date
     * If anything changes, it should invalidate the current RecurrenceRule
     */
    initialDateParsed(value) {
      if (value) {
        this.sendRecurring = sendRecurringBaseCase;
      }
    },
    /*
     * Callback to set the necessary details on recurrence.
     */
    sendRecurring: {
      handler(value) {
        if (value && value.recurrenceRule && value.startDate) {
          this.taskCopy.recurrenceRule = value.recurrenceRule;
          this.sendingScheduleDate = value;
        }
      },
      deep: true,
    },
    isEditTaskDrawerOpen(value) {
      if (value) {
        this.findTeamMembersIfNotLoaded();
        this.findCategoriesIfNotLoaded();
        this.loadEmailAccounts();
        this.loadVisibleContacts()
      }
    },
  },


  created() {
    this.taskCopy = { ...this.task };
    this.findCategories();
  },

  methods: {
    ...mapTasksActions([
      'findCategories',
      'findContacts',
      'saveTask',
      'processBulkTask',
      'migrateTasks',
      'findTasks',
      'setInProgress',
      'disableEnableBtn',
    ]),
    ...mapTeamMembersActions(['findTeamMembers']),
    ...mapEmailManagementActions(['loadEmailAccounts']),
    ...mapContactsTableActions(['searchVisibleContacts']),
    async bulkSaveTasks(taskCopy, bulkResources, bulkResourceString) {
      if (taskCopy.contactsSelected.length) {
        return this.processBulkTask({ task: taskCopy })
      }
      await Promise.all(
        bulkResources.map(async bulkResource => {
          taskCopy[bulkResourceString] = bulkResource;

          if (
            taskCopy.assignedUser &&
            taskCopy.assignedUser.value === CONTACT_ASSIGNED &&
            taskCopy.contact === null
          ) {
            taskCopy.assignedUser.value = this.user.id;
          }

          await this.saveTask({
            id: taskCopy.id,
            task: taskCopy,
          }).catch(error => {
            this.saveTaskErrors = [...this.saveTaskErrors, error];
          });
        }),
      );
    },
    manualyChanged(val) {
      this.taskCopy.recurrenceRule = '';
      this.manualStartDate = dateFns.parse(this.taskCopy.dueDate);
    },
    cancelSavingRecurringTask() {
      this.showSavingRecurringTask = false;
    },
    setKeepInSync() {
      this.taskCopy.is_two_way_sync = !this.taskCopy.is_two_way_sync;
    },
    initDueDateAsToday() {
      const formated = dateFns.format(new Date(), Preferences.DEFAULT_DATE_FORMAT);
      this.taskCopy.dueDate = formated;
    },
    contactAssigneeSelected(isSelected) {
      this.disableEnableBtn(isSelected);
    },
    async migrateTask() {
      this.setInProgress(true);
      await this.migrateTasks({ ids: [this.id] });
      if (this.queryParams) {
        await this.findTasks(this.queryParams);
      }
      this.setInProgress(false);
      this.resetForm();
      this.$emit('changes-saved', false);
    },
    async saveTasks(saveRecurring) {
      if (this.$refs.form.validate()) {
        if (this.taskCopy.isRecurrent) {
          if (!saveRecurring && this.showSavingRecurringTask) {
            this.showSavingRecurringTask = false;
            this.taskCopy.updateType = 0;
            return;
          } else if (!saveRecurring && !this.showSavingRecurringTask) {
            this.showSavingRecurringTask = true;
            this.taskCopy.updateType = 0;
            return;
          } else if (this.taskCopy.updateType === 0) {
            this.showSavingRecurringTask = false;
            return;
          }
        }
        this.setInProgress(true);
        if (this.id) {  
          await this.saveTask({
            id: this.id,
            task: this.taskCopy,
            queryParams: this.queryParams,
          });
        } else if (this.taskCopy.assignedUsers.length && this.taskCopy.contactsSelected.length) {
          await Promise.all(
            this.taskCopy.assignedUsers.map(assignedUser => {
              this.taskCopy.assignedUser = assignedUser;
              return this.bulkSaveTasks(
                this.taskCopy,
                this.taskCopy.contactsSelected,
                'contact',
              );
            }),
          );
        } else if (
          this.taskCopy.assignedUsers.length &&
          this.taskCopy.contactsSelected.length === 0
        ) {
          await this.bulkSaveTasks(
            this.taskCopy,
            this.taskCopy.assignedUsers,
            'assignedUser',
          );
        } else if (
          this.taskCopy.contactsSelected.length &&
          this.taskCopy.assignedUsers.length === 0
        ) {
          await this.bulkSaveTasks(
            this.taskCopy,
            this.taskCopy.contactsSelected,
            'contact',
          );
        } else {
          await this.saveTask({
            task: this.taskCopy,
          });
        }
        this.sendRecurring = sendRecurringBaseCase;
        if (this.queryParams) {
          setTimeout(async () => {
            await this.findTasks(this.queryParams);
          }, UPDATE_TASK_INTERVAL);
        }
        this.showSavingRecurringTask = false;
        this.setInProgress(false);
        this.resetForm();
        this.$emit('changes-saved', false);
      }
    },
    resetForm() {
      this.$refs.form.reset();
      this.$emit('deselect-all');
      this.$emit('contact-updated');
    },
    findTeamMembersIfNotLoaded() {
      if (this.teamMembers.length === 0) {
        this.findTeamMembers();
      }
    },
    findCategoriesIfNotLoaded() {
      if (this.categories.length === 0) {
        this.findCategories();
      }
    },
    async loadVisibleContacts() {
      if (
        !this.isBulkTask || 
        (this.contactIds && this.contactIds.length === this.totalContactsSelected)
      ) return;

      await this.searchVisibleContacts();
      this.taskCopy.contactsSelected = this.visibleBulkContacts;
    },
    openContactsDialog() {
      this.showContactsDialog = true;
    },
    closeContactsDialog() {
      this.showContactsDialog = false;
    },
    setContactsPage(page) {
      this.page = page;
      this.skip = (page - 1) * this.limit;
    },
    setContactsPageLimit(limit) {
      this.limit = limit;
      this.setContactsPage(1)
    },
    removeItem(item) {
      const index = this.taskCopy.contactsSelected.findIndex(selectedItem => selectedItem.id === item.id);
      if (index !== -1) {
        this.taskCopy.contactsSelected = [
        ...this.taskCopy.contactsSelected.slice(0, index),
        ...this.taskCopy.contactsSelected.slice(index + 1),
      ];
      }
    },
  },
};
</script>

<style lang="scss">
.sync-toggle {
  padding-bottom: 14px;
}
.v-tooltip__content {
  a {
    color: #6e95c1 !important;
    text-decoration: underline;
  }
}
.clickable {
  .v-chip__content {
    cursor: pointer !important;
    pointer-events: all !important;
    color: var(--v-primary-base);
  }
}
</style>
